export default "__VITE_ASSET__DtIvZhxI__"